import React from 'react';
import { Button, ButtonGroup, Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DownloadIcon from '@mui/icons-material/Download';
import PropTypes from 'prop-types';

/**
 * PDF SplitButton - because users love choices
 * @param {string} mainLabel - The label for the main action.
 * @param {function} onMainClick - The function to call when the main button is clicked.
 * @param {boolean} disabled - Whether the button is disabled.
 * @param {Array<{label: string, onClick: function}>} options - Dropdown options.
 */
export default function PdfButton({ mainLabel, onMainClick, disabled, options }) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleOptionClick = (option) => {
        handleMenuClose();
        option.onClick();
    };

    return (
        <ButtonGroup variant="contained">
            <Button
                data-testid="pdf-button"
                onClick={onMainClick}
                startIcon={<DownloadIcon />}
                color="primary"
                disabled={disabled}>
                {mainLabel}
            </Button>
            <Button
                size="small"
                aria-controls={anchorEl ? 'pdf-button-menu' : undefined}
                aria-expanded={anchorEl ? 'true' : undefined}
                aria-label="pdf-options-toggle"
                aria-haspopup="menu"
                color="primary"
                onClick={handleMenuOpen}
                disabled={disabled}>
                <ArrowDropDownIcon />
            </Button>
            <Menu id="pdf-button-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                {options.map((option, idx) => (
                    <MenuItem key={option.label || idx} onClick={() => handleOptionClick(option)}>
                        {option.label}
                    </MenuItem>
                ))}
            </Menu>
        </ButtonGroup>
    );
}

PdfButton.propTypes = {
    mainLabel: PropTypes.string.isRequired,
    onMainClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
        })
    ).isRequired,
};
